import {EFileExtensions} from 'shared/constants/file-extensions';
import {EMimeTypes} from 'shared/constants/mime-types';

export const IGNORABLE_FIELDS_KEYS: string[] = [
    'externalServiceId',
];

export const SIGN_UPLOAD_EXTENSIONS = [
    EFileExtensions.BIN,
    EFileExtensions.SGN,
].toString();

export const FILE_UPLOAD_EXTENSIONS = [
    EMimeTypes.MS_EXCEL,
    EMimeTypes.MS_EXCEL_OPEN_XML,
    EMimeTypes.MS_WORD,
    EMimeTypes.MS_WORD_OPEN_XML,
    EMimeTypes.PDF,
    EMimeTypes.RTF,
    EMimeTypes.JPEG,
    EMimeTypes.TIFF,
    EMimeTypes.XML,
].toString();
